module.exports = __webpack_public_path__ + "img/exercise-book.569f8a19.jpg";